import { FC } from 'react'
import { useAppSelector } from '../../../redux'
import { Player } from '../..'
import { StyledLessonVideo } from '.'

const LessonVideo: FC = () => {
  const { lesson, loading } = useAppSelector((state) => state.course)

  if (!lesson?.video?.svid && !loading && !lesson?.thumbnail?.fileHttpLink) {
    return null
  }

  return (
    <StyledLessonVideo $loading={loading}>
      <Player
        svid={lesson?.video?.svid}
        thumbnail={lesson?.thumbnail?.fileHttpLink}
        loading={loading}
      />
    </StyledLessonVideo>
  )
}

export default LessonVideo
